export enum ViewMode {
    VIEW,
    EDIT,
    INSERT,
}

export enum InvoiceType {
    FRANCHISE = 'franchise',
    RECURRING = 'recurring',
    ENTRY = 'entry',
    VARIOUS = 'various',
    CREDIT = 'credit',
}

export enum Right {
    MANAGE_INVOICE_TYPES = 'manage_invoice_types',
    MANAGE_MASTER_DATA = 'manage_master_data',
}
